const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );

    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.setCartLink();

    this.parentElement.addEventListener(
      'shopify:section:select',
      () => this.open()
    );

    this.parentElement.addEventListener(
      'shopify:section:deselect',
      () => this.close()
    );
  }

  setCartLink() {
    document.querySelectorAll('[data-cart-link]').forEach(cartLink => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');

      cartLink.addEventListener('click', event => {
        event.preventDefault();
        this.open(cartLink);
      });

      cartLink.addEventListener('keydown', event => {
        if (event.code.toUpperCase() !== 'SPACE') return;

        event.preventDefault();
        this.open(cartLink);
      });
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);

    this.classList.add('is-visible');

    this.querySelector('.cart-drawer__inner')
      .setAttribute('aria-hidden', 'false');

    this.addEventListener(
      'transitionend',
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('is-visible');

    const drawerInner = this.querySelector('.cart-drawer__inner');

    if (drawerInner) {
      drawerInner.setAttribute('aria-hidden', 'true');
    }

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement || null);
    }

    const activeHeader =
      document.querySelector('#header') ||
      document.querySelector('#shopify-section-main-password-header header') ||
      document.querySelector('.sk-header');

    const isHeaderMenuOpen = Boolean(
      activeHeader &&
      activeHeader.classList.contains('menu-open')
    );

    if (!isHeaderMenuOpen) {
      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden');
    }

    if (window.location.pathname === '/cart') {
      const cartDrawerForm =
        document.getElementById('CartDrawer-FormSummary');

      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement =
        document.querySelector(section.id);

      const sectionHTML =
        response.sections?.[section.section];

      if (!sectionElement || !sectionHTML) return;

      const innerHTML = this.getSectionInnerHTML(
        sectionHTML,
        section.selector
      );

      if (innerHTML !== null) {
        sectionElement.innerHTML = innerHTML;
      }
    });

    this.updateCustomCartCount(response);

    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return element ? element.innerHTML : null;
  }

  updateCustomCartCount(response) {
    const counterHTML =
      response.sections?.['cart-counter'];

    if (!counterHTML) return;

    const doc = new DOMParser()
      .parseFromString(counterHTML, 'text/html');

    const badge =
      doc.querySelector('.cart-count-badge');

    const rawCount =
      badge?.textContent?.trim() || '0';

    const isEmpty =
      !badge ||
      badge.classList.contains('hidden') ||
      rawCount === '' ||
      rawCount === '0';

    document
      .querySelectorAll('[data-cart-count]')
      .forEach(counter => {
        counter.textContent =
          isEmpty ? '0' : rawCount;

        counter.hidden = isEmpty;
      });
  }

  focusOnCartDrawer() {
    const cartDrawer =
      this.querySelector('.cart-drawer');

    if (cartDrawer) {
      cartDrawer.focus();
    }
  }
}

customElements.define(
  'cart-drawer',
  CartDrawer
);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define(
  'cart-drawer-items',
  CartDrawerItems
);